import { Link } from "react-router-dom";
import { LegalPage, LegalSection, LegalList, CompanyBox, COMPANY } from "./LegalPage";

export default function Termini() {
  return (
    <LegalPage
      testid="termini-page"
      eyebrow="Legale"
      title="Termini e Condizioni"
      intro="I presenti Termini e Condizioni regolano l'utilizzo del sito ViviTranquillo.com e dei servizi offerti da Hyper Consult SRL."
    >
      <CompanyBox />

      <LegalSection title="Informazioni generali">
        <p>
          ViviTranquillo.com è un servizio di {COMPANY.name}. Utilizzando il sito e attivando i servizi, il Cliente
          accetta integralmente i presenti Termini e Condizioni. ViviTranquillo svolge un'attività di assistenza e
          supporto e non si sostituisce ai soggetti competenti eventualmente coinvolti nelle singole pratiche.
        </p>
      </LegalSection>

      <LegalSection n="1" title="Piano ViviTranquillo">
        <p>Il Piano ViviTranquillo è un abbonamento con le seguenti durate e prezzi:</p>
        <LegalList
          items={[
            "1 anno – €49",
            "2 anni – €89",
            "3 anni – €129",
            "Rinnovo automatico per la stessa durata scelta, salvo disattivazione da parte del Cliente prima della scadenza.",
            "3 richieste di assistenza per ogni anno di copertura.",
            "Le richieste non utilizzate NON si accumulano e scadono al termine di ciascun anno di copertura.",
            "Richieste extra illimitate al prezzo di €19,90 ciascuna, una tantum, utilizzabili nell'anno di copertura in corso.",
          ]}
        />
        <p>
          La disattivazione del rinnovo automatico può essere effettuata in qualsiasi momento dalla propria Area Clienti:
          il Piano resta attivo fino alla fine del periodo già pagato e non viene effettuato alcun ulteriore addebito.
        </p>
      </LegalSection>

      <LegalSection n="2" title="Servizi separati (una tantum)">
        <p>I seguenti servizi sono separati dal Piano ViviTranquillo e dalle richieste in esso incluse:</p>
        <LegalList
          items={[
            "Controllo CRIF – €49 una tantum.",
            "Controllo Banche Dati Completo (CTC · Experian · Banca d'Italia) – €99 una tantum.",
            "Per questi servizi NON è previsto alcun rinnovo automatico.",
            "Tempistica massima indicativa: 30 giorni dal ricevimento della documentazione completa.",
          ]}
        />
      </LegalSection>

      <LegalSection n="3" title="Delega e documenti obbligatori">
        <p>
          Per i servizi Controllo CRIF e Controllo Banche Dati, il Cliente delega ViviTranquillo.com ({COMPANY.name})
          a presentare e gestire la richiesta per proprio conto nei confronti dei soggetti competenti (a titolo
          esemplificativo CRIF, CTC, Experian, Banca d'Italia), nei limiti delle autorizzazioni e dei consensi forniti.
        </p>
        <p>La pratica non può essere avviata senza i seguenti documenti:</p>
        <LegalList
          items={[
            "Documento di identità in corso di validità (fronte e retro).",
            "Tessera sanitaria.",
          ]}
        />
        <p>
          In assenza di tali documenti la richiesta resta in stato "Documenti necessari" e non viene inoltrata ai
          soggetti competenti.
        </p>
      </LegalSection>

      <LegalSection n="4" title='Garanzia "Soddisfatti o rimborsati"'>
        <p>
          La garanzia "Soddisfatti o rimborsati" si applica esclusivamente come garanzia sulla differenza di prezzo
          dell'offerta proposta da ViviTranquillo rispetto alle condizioni preesistenti del Cliente, secondo condizioni
          verificabili e sulla base della documentazione fornita dal Cliente.
        </p>
        <p>
          La garanzia non costituisce in alcun caso un rimborso totale generico del servizio, né una garanzia di
          risultato. L'applicazione della garanzia è subordinata alla verifica della documentazione e delle condizioni
          dichiarate.
        </p>
      </LegalSection>

      <LegalSection n="5" title="Diritto di recesso">
        <p>
          Per gli abbonamenti al Piano ViviTranquillo (annuale, biennale e triennale) e per i servizi, il cliente dispone
          del diritto di recesso di 14 giorni previsto dalla normativa. Se il cliente richiede l'avvio del servizio
          durante i 14 giorni di recesso e successivamente esercita il recesso, potrà essere dovuto un importo
          proporzionato alle prestazioni effettivamente eseguite, nei limiti di legge, tenendo conto delle richieste
          utilizzate (da 1 a 3) e degli eventuali costi di gestione legittimamente addebitabili, preventivamente
          comunicati e documentabili. L'eventuale importo residuo sarà rimborsato secondo la normativa vigente.
        </p>
        <p>
          La perdita del diritto di recesso per un servizio completamente eseguito deve rispettare i requisiti di
          consenso e riconoscimento previsti dalla normativa, in particolare il consenso espresso del cliente all'avvio
          immediato e il riconoscimento della conseguente perdita del diritto una volta che il servizio sia stato
          interamente eseguito.
        </p>
      </LegalSection>

      <LegalSection title="Pagamenti">
        <p>
          I pagamenti sono gestiti in modo sicuro tramite il provider Stripe. ViviTranquillo non conserva i dati della
          carta del Cliente. Le ricevute dei pagamenti sono disponibili nell'Area Clienti.
        </p>
      </LegalSection>

      <LegalSection title="Trattamento dei dati personali">
        <p>
          Il trattamento dei dati personali è descritto nella{" "}
          <Link to="/privacy" className="font-semibold text-[#10B981] hover:underline">Privacy Policy</Link>. L'uso dei
          cookie è descritto nella{" "}
          <Link to="/cookie" className="font-semibold text-[#10B981] hover:underline">Cookie Policy</Link>.
        </p>
      </LegalSection>

      <LegalSection title="Legge applicabile e contatti">
        <p>
          I presenti Termini sono regolati dalla legge italiana. Per qualsiasi informazione è possibile contattare{" "}
          {COMPANY.name} all'indirizzo {COMPANY.email} o via PEC {COMPANY.pec}.
        </p>
      </LegalSection>
    </LegalPage>
  );
}
